import clsx from "clsx";
import React from "react";

interface IBadgeProps
  extends Pick<React.HTMLProps<HTMLSpanElement>, "className"> {
  children: React.ReactNode;
}

export default function Badge(props: IBadgeProps) {
  return (
    <span
      className={clsx(
        "flex p-1 justify-center items-center rounded-[6px] bg-badge-purple font-medium text-secondary disabled:opacity-40",
        props.className,
      )}
    >
      {props.children}
    </span>
  );
}
